import React from "react";
import { Box, Button, Typography } from "@mui/material";

/**
 * Catches render errors so the SPA does not show a blank white screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== "production") {
      console.error("CSRP UI error:", error, errorInfo);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoLogin = () => {
    window.location.href = "/login";
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          p: 3,
          bgcolor: "#f5f5f5",
        }}
      >
        <Typography variant="h5" component="h1">
          Something went wrong
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ maxWidth: 480 }}>
          The application encountered an unexpected error. You can reload the page or return to the login screen.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
          <Button variant="contained" onClick={this.handleReload}>
            Reload page
          </Button>
          <Button variant="outlined" onClick={this.handleGoLogin}>
            Go to login
          </Button>
        </Box>
      </Box>
    );
  }
}

export default ErrorBoundary;
